const Enum = {
    AVAILABLE_BOOKING: {
        COL_RESEARCHER: 'COL_RESEARCHER',
        SELF_RESEARCHER: 'SELF_RESEARCHER',
    },
    WEEKS: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
}

export default Enum;